// reducers/connect/sources.js

export function connectSourcesHasErrored(state = false, action) {
  switch (action.type) {
    case 'CONNECT_SOURCES_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}

export function connectSourcesIsLoading(state = true, action) {
  switch (action.type) {
    case 'CONNECT_SOURCES_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

export function connectSources(state = [], action) {
  switch(action.type) {
    case 'CONNECT_SOURCES_FETCH_DATA_SUCCESS':
      return action.list;
    default:
      return state;
  }
}